module.exports = __webpack_public_path__ + "static/img/al4.db89e19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/al4.jpg
// module id = KFUV
// module chunks = 0